import type { ComponentProps } from 'react';

import { Col } from '@opendoor/atoms/box';
import { determinePropertyActionability } from 'components/marketplace/helpers/propertyActionability';
import type { MarketplaceProperty } from 'components/marketplace/property/types';

import { BuyDirectCTA } from '../BuyDirectCTA';
import { BuyWithConfidence } from '../BuyWithConfidence';
import type { CertaintyTreatment } from './CertaintyPanel';
import { GuaranteeCard } from './CertaintyPanel/GuaranteeCard';

type PropertyCTAsData = ComponentProps<typeof BuyDirectCTA>['property'] &
  Pick<MarketplaceProperty, 'shouldShowGuarantee'>;

interface PropertyCTAsProps {
  property: PropertyCTAsData;
  // Certainty-panel treatment only; null renders the unchanged control page.
  certainty?: CertaintyTreatment | null;
}

export const PropertyCTAs = ({ property, certainty = null }: PropertyCTAsProps) => {
  const { isActionable, tourKind } = determinePropertyActionability(property);

  if (!isActionable || !tourKind) {
    return null;
  }

  const showGuaranteeCard = certainty?.showGuaranteeCard ?? false;

  return (
    <Col className="gap-12 px-0 pt-12">
      <BuyDirectCTA
        property={property}
        certaintyStats={certainty?.buyBoxStats ?? null}
        hideTrustBadges={showGuaranteeCard}
      />
      {property.shouldShowGuarantee &&
        (certainty ? (
          <GuaranteeCard
            addressToken={property.addressToken}
            showMortgageCta={certainty.showMortgageCta}
          />
        ) : (
          <BuyWithConfidence />
        ))}
    </Col>
  );
};
